export const smsSearchData = (data: any, text: any) => {
  const searchResp = data.filter((list: any) => {
    const did = list.your_number.toString();
    if (did.includes(text)) {
      return list;
    }
  });
  return searchResp;
};

export const resetFilter = (state: any) => {
  state.smsList = state.smsData;
};
